import type { TranslationTree } from '../../types';

export const common: TranslationTree = {
  common: {
    brand: 'ToolLife',
    loading: 'Chargement en cours…',
    close: 'Fermer',
    clearSelection: 'Effacer la sélection',
    required: 'obligatoire',
    retry: 'Réessayer',
    confirm: 'Confirmer',
    delete: 'Supprimer',
    remove: 'Retirer',
    removeItem: 'Retirer {{item}}',
    breadcrumb: "Fil d'Ariane",
    back: 'Retour',
    search: 'Rechercher',
    notProvided: 'Non renseigné',
    loadingShort: 'Chargement…',
    cancel: 'Annuler',
    chooseTheme: 'Choisir un thème',
    themeLight: 'Clair',
    themeDark: 'Sombre',
    reference: 'Référence',
    logoAlt: 'Logo Louis Bélet',
  },
  form: {
    validation: {
      requiredTooltip: 'Ce champ est obligatoire.',
      requiredMultiTooltip: "Au moins un des champs marqués d'un * orange doit être rempli.",
      requiredMultiAtLeastOne: 'Au moins un champ doit être rempli.',
      checkboxAtLeastOne: 'Veuillez sélectionner au moins une option.',
    },
    numberInput: {
      increase: 'Augmenter la valeur',
      decrease: 'Diminuer la valeur',
    },
    select: {
      options: 'Sélectionnez une option',
    },
  },
};
